import React, {
    useEffect,
    useState
} from "react";
import {
    Accordion,
    AccordionItem,
    Link,
    Spacer
} from "@nextui-org/react";
import Ajax from "../inc/js/Ajax";
import {
    HelmetWrapper
} from "../inc/js/Helper"
import {
    QuestionMark_96_Blue_200
} from "../inc/images/svgs";

export default function FAQ() {
    const [FAQData, setFAQData] = useState([]);

    useEffect(() => {
        Ajax.request({
            url:"/JudgeAutos/readFAQs",
            success:function(reply) {
                if(reply.data) {
                    setFAQData(reply.data);
                }
            }
        });
    }, []);

    return(
        <>
            <HelmetWrapper
                title="JudgeAutos - FAQ"
                description="Find answers to frequently asked questions about using JudgeAutos for car show registration, judging, and event management."
                url="FAQ"
            />

            <div className="mx-auto w-11/12 sm:w-1/3 text-center">
                <div className="relative w-full h-64 mb-12">
                    <div className="absolute inset-0 flex justify-center items-center z-0">
                        <QuestionMark_96_Blue_200 />
                    </div>
                    <div className="relative z-10 flex justify-center items-center h-full">
                        <h1 className="text-4xl font-bold flex flex-col items-center">
                        <span>Frequently</span>
                        <span>Asked</span>
                        <span>Questions</span>
                        </h1>
                    </div>
                </div>
                
                <div className="w-full max-w-full mx-auto p-5 border-solid border-2 rounded-2xl">
                    <Accordion>
                        {FAQData.map((data, index) => (
                            <AccordionItem
                                key={index}
                                aria-label={`FAQ Accordion ${index}`}
                                classNames={{
                                    title: "text-center",
                                    content: "text-left"
                                }}
                                title={data.question}
                            >
                                <div className="-mt-3 sm:max-w-sm md:max-w-full md:min-w-full" dangerouslySetInnerHTML={{ __html: data.answer }} />
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
                <Spacer y={10} />
                <p className="text-2xl -mb-10">
                    Can't find the answer? <Link href="/ContactUs" className="text-2xl">Contact Us</Link> to ask your question!
                </p>
            </div>
        </>
    );
}